<template>
  <v-dialog
      v-model="isVisibleWindow"
      scrollable
      max-width="800"
      max-height="90%"
      min-width="90%"
  >
    <v-card>
      <v-card-actions>
        <h3 class="pl-2">
          {{ $t('catalogs_groups.code_for_site') }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideWin">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text>
        <v-card
            class="mx-auto mt-2"
        >
          <v-card-title>
            <h5>{{ $t('catalogs_groups.iframe_code') }}</h5>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-textarea
                v-model="iframe"
                ref="iframe"
                outlined
                height="200px"
                hide-details
                readonly
                no-resize
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="copyText('iframe')"
                        fab
                    >
                      <v-icon>mdi-clipboard-text</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('common.copy') }}</span>
                </v-tooltip>
              </template>
            </v-textarea>
          </v-card-text>
        </v-card>

        <v-card
            class="mx-auto mt-3"
        >
          <v-card-title>
            <h5>{{ $t('catalogs_groups.insert_a_link_to_the_catalog') }}</h5>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-textarea
                v-model="href"
                ref="href"
                outlined
                hide-details
                readonly
                no-resize
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="copyText('href')"
                        fab
                    >
                      <v-icon>mdi-clipboard-text</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('common.copy') }}</span>
                </v-tooltip>
              </template>
            </v-textarea>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider class=""></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" elevation="0" color="red" @click="hideWin" small >
          {{ $t("common.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import i18n from "@/i18n";

export default {
  name: "CodeWindow",
  props: {
    link: null,
    image: null,
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
  }),
  computed:{
    href:{
      get(){
        return `<a href="${this.link}">`+"\n"+
        `    <img src="${this.image}">`+"\n"+
        `</a>`;
      },
      set(){

      }
    },
    iframe:{
      get(){
        return `<script src="https://img.catalogs-parts.com/js/frame.js">`+`</`+`script>`+"\n"+
        `<iframe id="cp_frame" name="cp_frame"`+"\n"+
        `  src="${this.link}"`+"\n"+
        `  onLoad="FrameManager.registerFrame(this)" scrolling="no" frameBorder="0" marginHeight="0" marginWidth="0"`+
        `  width="100%">`+"\n"+
        `</iframe>`
      },
      set(){

      }
    },
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods:{
    hideWin() {
      this.isVisibleWindow = false;
    },
    copyText(ref) {
      this.$nextTick(() => {
        let textToCopy = this.$refs[ref].$el.querySelector("textarea");
        textToCopy.select();
        document.execCommand("copy");
        this.$inform(i18n.t("common.text_has_been_copied_to_clipboard"));
      });
    },
  },
}
</script>

<style scoped>

</style>